module.exports = __webpack_public_path__ + "media/images/credit-bg-fe6b04c4d82a30870f4270734b13e2cc.png";